<template>
  <section id="depenser" class="Exercise">
    <div class="Exercise__head">
      <h2 class="Exercise__title" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-32'">Pour se dépenser</h2>
      <p v-if="text" class="Exercise__lead raleway-reg-p15">{{ text }}</p>
    </div>

    <div class="Exercise__railWrap mt-5" v-if="images && images.length">
      <button
        class="Nav Nav--prev"
        :class="{ 'is-disabled': atStart }"
        @click="scroll(-1)"
        aria-label="Précédent"
      >
        ‹
      </button>

      <div class="Exercise__rail" ref="rail" @scroll.passive="onScroll">
        <article
          v-for="(src, i) in images"
          :key="i"
          class="Slide"
          :class="offsetClass(i)"
        >
          <div class="Slide__imgWrap">
            <img :src="src" :alt="captions[i] || `Activité ${i+1}`" loading="lazy" />
          </div>
          <h4 v-if="captions[i]" class="Slide__caption">{{ captions[i] }}</h4>
        </article>
      </div>

      <button
        class="Nav Nav--next"
        :class="{ 'is-disabled': atEnd }"
        @click="scroll(1)"
        aria-label="Suivant"
      >
        ›
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ExerciseSection',
  props: {
    text: { type: String, default: '' },
    images: { type: Array, default: () => [] },
    captions: { type: Array, default: () => [] }
  },
  data () {
    return { atStart: true, atEnd: false, isPhone: window.innerWidth < 768 }
  },
  mounted () {
    this.$nextTick(() => {
      this.onScroll()
    })
    window.addEventListener('resize', this.onScroll, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onScroll)
  },
  methods: {
    offsetClass (i) {
      return (i % 2 === 0) ? 'is-up' : 'is-down'
    },
    cardStep () {
      const rail = this.$refs.rail
      if (!rail) return 320
      const slide = rail.querySelector('.Slide')
      if (!slide) return 320
      const styles = window.getComputedStyle(rail)
      const gap = parseInt(styles.columnGap || styles.gap || '16', 10)
      return slide.getBoundingClientRect().width + gap
    },
    scroll (dir = 1) {
      const rail = this.$refs.rail
      if (!rail) return
      rail.scrollBy({ left: dir * this.cardStep(), behavior: 'smooth' })
    },
    onScroll () {
      const rail = this.$refs.rail
      if (!rail) return
      const max = rail.scrollWidth - rail.clientWidth - 2
      this.atStart = rail.scrollLeft <= 2
      this.atEnd   = rail.scrollLeft >= max
    }
  }
}
</script>

<style>
.Exercise { padding: 24px 16px 8px; }
.Exercise__head { max-width: 1100px; margin: 0 auto 14px; text-align: center; }
.Exercise__title {
  margin: 0 0 8px;
}
.Exercise__lead {
  max-width: 1000px;
  margin: 0 auto;
  line-height: 1.9;
  color: #1a1a1a;
}

.Exercise__railWrap {
  position: relative;
  max-width: 1200px;  
  margin: 0 auto;
  padding-inline: 32px; 
}

.Exercise__rail {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: clamp(260px, 28vw, 360px);
  gap: 20px;

  overflow-x: auto;
  overscroll-behavior-x: contain;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;

  padding: 6px 10px 18px;
  -webkit-overflow-scrolling: touch;
}

.Exercise__rail::-webkit-scrollbar { height: 0; }
.Exercise__rail { scrollbar-width: none; }
.Exercise__rail::-webkit-scrollbar-thumb { background: transparent; }

.Slide {
  scroll-snap-align: start;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  transition: transform .25s ease;
}
.Slide__imgWrap {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
}
.Slide__imgWrap img {
  width: 100%; height: 100%; object-fit: cover; display: block;
}
.Slide__caption {
  margin: 10px 6px 2px;
  font-weight: 800;
  letter-spacing: .2px;
}

@media (min-width: 900px) {
  .Slide.is-up   { transform: translateY(-34px); }
  .Slide.is-down { transform: translateY(34px); }
}

@media (max-width: 899px) {
  .Exercise__rail { grid-auto-columns: 80vw; gap: 14px; }
  .Slide.is-up, .Slide.is-down { transform: none; }
}

.Nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  width: 42px; height: 42px;
  border-radius: 50%;
  border: 1px solid rgba(0,0,0,.2);
  background: rgba(255,255,255,.95);
  color: #111;
  font-size: 26px; line-height: 38px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 2px 8px rgba(0,0,0,.10);
}
.Nav--prev { left: 0;  transform: translate(-50%, -50%); }
.Nav--next { right: 0; transform: translate(50%, -50%); }
.Nav.is-disabled { opacity: .35; pointer-events: none; }

@media (max-width: 680px){
  .Nav--prev { left: 8px;  transform: translateY(-50%); }
  .Nav--next { right: 8px; transform: translateY(-50%); }
}
</style>